import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Label,
} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

import {
  estimateFileUpload,
  getEstimateFromFile,
  cartFileUpload,
  updatePriceCartByCustomer,
  suggestionNomenclatrue2,
  searchPrice2,
} from "services/api";
import { tableBrandColumns } from "./tableData";
import { OrderForm } from "features/Dashboard/OrderForm";
import { CartTable } from "features/Cart/CartTable";
import useQuery from "utils/useQuery";
import { AutocompleteArticle } from "features/Dashboard/AutocompleteArticle";
import { useCart } from "features/Cart/CartContext";
import { CreateProductModal } from "features/Dashboard/CreateProductModal";
import { MySpinner } from "components/MySpinner";
import { HeaderPage } from "components/HeaderPage";
import { SearchResultTable } from "features/Dashboard/SearchResultTable";
import { DashboardToolbar } from "features/Dashboard/DashboardToolbar";
import { EstimateTable } from "features/Dashboard/EstimateTable";
import { BrandFilter } from "features/Dashboard/BrandFilter";
import { articleNormalize } from "utils/articleNormalizer";
import { useUser } from "features/Users/UserContext";

import "./dashboard.scss";

export const PROVIDERS = [
  "omega",
  "corona",
  "armtek",
  "favorit",
  "forum",
];

export const sortResult = (items) => {
  return items.sort(function (a, b) {
    if (a.inStock === false && b.inStock === true) {
      return 1;
    }

    if (a.inStock === true && b.inStock === false) {
      return -1;
    }

    if (a.inTransit === false && b.inTransit === true) {
      return 1;
    }

    if (a.inTransit === true && b.inTransit === false) {
      return -1;
    }

    if (parseInt(a.price * 100) && parseInt(b.price * 100)) {
      if (parseInt(a.price * 100) > parseInt(b.price * 100)) {
        return 1;
      }
      if (parseInt(a.price * 100) < parseInt(b.price * 100)) {
        return -1;
      }
    }
    return 0;
  });
};

export const filterNotOurProvider = (data) => {
  if (!data) {
    return [];
  }

  return data.filter(v => v.providerId !== '518680fd-6d10-4543-96a4-108534ba69ca')
}

export const DashboardPage = ({ title }) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const query = useQuery(useLocation);
  const inputEstimateFile = useRef();
  const inputOrderFile = useRef(null);
  const { user } = useUser();
  const [allResults, setAllResults] = useState([]);
  const [allAnalogs, setAllAnalogs] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState(new Set());
  const [result, setResult] = useState([]);
  const [analogs, setAnalogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSearchResult, setIsSearchResult] = useState(false);
  const [headerLoading, setHeaderLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [brands, setBrands] = useState([]);
  const [article, setArticle] = useState(query.get("article") || "");
  const [brand, setBrand] = useState(query.get("brand") || "");
  const [estimateFromFile, setEstimateFromFile] = useState([]);
  const [estimateFile, setEstimateFile] = useState(null);
  const [orderFile, setOrderFile] = useState(null);
  const [fileName, setFileName] = useState(query.get("file") || "");
  const [customer, setCustomer] = useState(
    JSON.parse(localStorage.getItem("customer")) || null
  );
  const [account, setAccount] = useState(null);
  const [orderSuccess, setOrderSuccess] = useState(false);
  const { setCart, cart } = useCart();
  const [orderUploadLoading, setOrderUploadLoading] = useState(false);
  const [id, setId] = useState(null);
  const [errors, setErrors] = useState({});
  const [apiProviders, setApiProviders] = useState({});

  const scrollRef = useRef(null);
  const selectedRef = useRef(null);

  const searchResultConvert = (res) => {
    const output = [];
    Object.entries(res.data).map(([brand, value]) => {
      Object.entries(value).map(([article, value]) => {
        value.offer.map((item) => {
          output.push({
            id: item.id,
            article: item.article,
            articleSearch: article,
            status: value.status,
            minStock: value.minStock,
            name: value.name,
            brand,
            nomenclature: {
              id: value.nomenclatureId,
              image: value.image,
            },
            dateArrival: item.dateArrival || null,
            inTransit: item.inTransit || false,
            exist: item.exist || 0,
            price: item.price || 0,
            fixPrice: item.fixPrice || null,
            pricePurchase: item.cost,
            existReserve: item.existReserve,
            providerId: item.providerId,
            providerName: item.providerName,
            warehouseId: item.warehouseId,
            warehouseName: item.warehouseName,
            priceListId: item.priceListId,
            priceListName: item.priceListName,
            our: item.inStock,
            inStock: item.inStock,
            dateUpdate: item.priceListDateUpdate,
            multiplicity: item.multiplicity,
            warehouseBranch: item.warehouseBranch,
            delayDayCount: item.delayDayCount,
            delayDayCountCustomer: item.delayDayCountCustomer
          });
        });
        return null;
      });
    });
    return output;
  };

  const searchPriceByProvider = (provider, article, brand, callback) => {
    setApiProviders(prev => ({
      ...prev, [provider]: {
        loading: true
      }
    }));

    searchPrice2({ article: article.replace("/", ""), brand, userId: account?.value, provider, adminId: user?.id })
      .then((res) => {

        if (res.error) {
          setErrors(prev => ({ ...prev, ...res.error }));
        }

        if (res.group) {
          setBrands(res.group);
          setLoading(false);
          if (res.group.length === 0) {
            setApiProviders({});
          }

          setIsSearchResult(true);

          return;
        }

        if (!res.data) {
          setApiProviders({});
          setLoading(false);
          return;
        }

        if (!brand && res.info?.brand) {
          setBrand(res.info.brand);
        }

        setApiProviders(prev => ({
          ...prev, [provider]: {
            responceTime: res.responceTime || null,
            loading: false
          }
        }));


        const newResults = searchResultConvert(res).filter(
          (item) => item.articleSearch === articleNormalize(article) && item.brand === (brand || res.info?.brand)
        );
        const newAnalogs = searchResultConvert(res).filter(
          (item) => item.articleSearch !== articleNormalize(article) || item.brand !== (brand || res.info?.brand)
        );

        setAllResults((prev) => sortResult([...prev, ...newResults]));
        setAllAnalogs((prev) => sortResult([...prev, ...newAnalogs]));

        setBrands([]);

        if (callback) {
          callback();
        }
      })
      .catch(e => {
        if (e.response?.status) {
          toast.error(`Ошибка 500 ${provider}`);
        }
      })
      .finally(() => {
        setProgress(prev => (prev + 1));
      });
  }

  const searchProviders = (article, brand = null) => {
    if (!user?.id) return;
    setAllResults([]);
    setAllAnalogs([]);
    setResult([]);
    setAnalogs([]);
    setSelectedBrands(new Set());
    setLoading(true);
    setProgress(0);
    setIsSearchResult(false);

    searchPriceByProvider("", article, brand, function () {
      PROVIDERS.forEach((provider, i) => {
        searchPriceByProvider(provider, article, brand);
      });
    });
  };

  const getAndSetPrice = (article, brand = null) => {
    if (loading) return;
    setBrands([]);
    if (!article) return;

    searchProviders(article, brand);
  };

  useEffect(() => {
    if (progress > PROVIDERS.length) {
      setLoading(false);
    }
  }, [progress]);

  useEffect(() => {
    if (!orderSuccess) return;
    setBrands([]);
    setArticle("");
    setBrand("");
  }, [orderSuccess]);

  useEffect(() => {
    const url = new URLSearchParams();
    if (fileName) {
      url.append("file", fileName);
    }
    if (article) {
      url.append("article", article);
    }
    if (brand) {
      url.append("brand", brand);
    }

    if (url) {
      history.push(`${pathname}?${url}`);
    } else {
      history.push(pathname);
    }

    if (article && article.length < 2) {
      return;
    }

    if (customer?.value && !account?.value) {
      return;
    }
    getAndSetPrice(article, brand);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileName, article, brand, user?.id, account?.value]);

  useEffect(() => {
    if (customer) {
      localStorage.setItem("customer", JSON.stringify(customer));
    } else {
      localStorage.removeItem("customer");
    }

    if (!cart.length) return;

    updatePriceCartByCustomer({ customer: customer?.value })
      .then((res) => {
        setCart(res.cart);
      })
      .finally(() => { });
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customer]);

  const estimateHandler = ({ article, brand }) => {
    if (!loading) {
      setArticle(article);
      setBrand(brand);
    }
  };

  const brandHandler = {
    onClick: (_, row) => {
      if (!loading) {
        setArticle(row.partNumber);
        setBrand(row.brand);
      }
    },
  };

  const getEstimateFile = () => {
    if (inputEstimateFile) {
      inputEstimateFile.current.click();
    }
  };

  const getOrderFile = () => {
    if (inputOrderFile) {
      inputOrderFile.current.click();
    }
  };

  useEffect(() => {
    if (!fileName) return;
    getEstimateFromFile({ fileName })
      .then((res) => {
        setEstimateFromFile(res);
        if (scrollRef.current && selectedRef.current) {
          scrollRef.current.scrollTop = selectedRef.current.offsetTop - 40;
        }
      })
      .finally();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!estimateFile) return;
    const formData = new FormData();
    formData.append("file", estimateFile);
    estimateFileUpload(formData)
      .then((res) => {
        setEstimateFromFile(res.items);
        setFileName(res.file);
      })
      .finally();
  }, [estimateFile]);

  useEffect(() => {
    if (!orderFile) return;
    setOrderUploadLoading(true);
    const formData = new FormData();
    formData.append("file", orderFile);
    cartFileUpload(formData)
      .then((res) => {
        setCart(res.cart);
        setCustomer({ label: res.customer?.name, value: res.customer?.id });
        localStorage.setItem(
          "customer",
          JSON.stringify({
            label: res.customer?.name,
            value: res.customer?.value,
          })
        );
      })
      .finally(() => {
        setOrderUploadLoading(false);
        inputOrderFile.current.value = "";
      });
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderFile]);

  // Функция фильтрации по выбранным брендам
  const filterByBrands = React.useCallback((brandsSet) => {
    if (brandsSet.size === 0) {
      setResult([]);
      setAnalogs([]);
      return;
    }

    const filteredResults = allResults.filter((item) => brandsSet.has(item.brand));
    const filteredAnalogs = allAnalogs.filter((item) => brandsSet.has(item.brand));

    setResult(filteredResults);
    setAnalogs(filteredAnalogs);
  }, [allResults, allAnalogs]);

  // Применяем фильтр при изменении выбранных брендов
  useEffect(() => {
    filterByBrands(selectedBrands);
  }, [selectedBrands, filterByBrands]);

  // При первом появлении данных автоматически выбираем все бренды
  useEffect(() => {
    if (allResults.length > 0 || allAnalogs.length > 0) {
      const allBrands = new Set([...allResults, ...allAnalogs].map(item => item.brand).filter(Boolean));
      if (allBrands.size > 0) {
        // Если бренды еще не выбраны или выбраны не все - выбираем все
        const currentBrandsArray = Array.from(selectedBrands);
        const allBrandsArray = Array.from(allBrands);
        const areAllSelected = allBrandsArray.every(brand => selectedBrands.has(brand)) &&
          currentBrandsArray.every(brand => allBrands.has(brand)) &&
          selectedBrands.size === allBrands.size;

        if (!areAllSelected) {
          setSelectedBrands(allBrands);
        }
      }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allResults.length, allAnalogs.length]);

  return (
    <Container fluid className="p-0 dashboard">
      <HeaderPage title="Поиск детали" Element={CreateProductModal} />

      <Card className="mb-0">
        <CardBody className="pb-0">
          {headerLoading && <MySpinner overlay />}
          <Row>
            <Col lg="5">
              <form>
                <div>
                  <Label>Поиск запчастей</Label>
                  <AutocompleteArticle
                    searchButton={true}
                    article={article}
                    brand={brand}
                    setArticle={setArticle}
                    setBrand={({ id, name }) => setBrand(name)}
                    getAndSetPrice={getAndSetPrice}
                    size
                    func={suggestionNomenclatrue2}
                  />
                  {brand && <h5 className="mt-2">{brand}</h5>}
                </div>
              </form>
            </Col>
            <Col lg="7" className="dashboard__buttons-block flex">
              <DashboardToolbar
                fileName={fileName}
                setFileName={setFileName}
                getEstimateFile={getEstimateFile}
                setEstimateFile={setEstimateFile}
                inputEstimateFile={inputEstimateFile}
                getOrderFile={getOrderFile}
                inputOrderFile={inputOrderFile}
                setOrderFile={setOrderFile}
              />
            </Col>
          </Row>
          <Row>
            <Col lg="6">
              {brands.length > 0 && (
                <BootstrapTable
                  rowEvents={brandHandler}
                  keyField="brand"
                  data={brands}
                  hover={true}
                  columns={tableBrandColumns}
                  bootstrap4
                  bordered={false}
                />
              )}
            </Col>
          </Row>
        </CardBody>
      </Card>

      <div className="dashboard__search-result">
        {fileName && (
          <Card className="dashboard__search-left">
            <CardBody>
              <h4 className="mb-4">Проценка из файла</h4>

              <EstimateTable
                estimateFromFile={estimateFromFile}
                selectedRef={selectedRef}
                article={article}
                estimateHandler={estimateHandler}
                scrollRef={scrollRef}
              />
            </CardBody>
          </Card>
        )}


        <Row className="dashboard__search-right">
          <Col lg="12">
            <div className="results">
              <Card className="mb-0">
                <CardBody className="pb-1">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h3 className="mb-0">
                      Результаты поиска
                      {result.length > 0 && (
                        <span className="ml-2 dashboard__results-count">
                          {result.length}
                        </span>
                      )}
                      {loading && <MySpinner />}
                    </h3>
                    <BrandFilter
                      result={allResults}
                      analogs={allAnalogs}
                      selectedBrands={selectedBrands}
                      onBrandsChange={setSelectedBrands}
                    />
                  </div>
                  {errors && <ul className="errors">
                    {Object.entries(errors).map(([key, error]) => <li key={key}>
                      {key}: {error}
                    </li>)}
                  </ul>}

                  <div className="apiResults">
                    {Object.entries(apiProviders).map(([provider, info]) =>
                      <div key={provider} className="apiResult">
                        {info?.loading && <MySpinner width="10px" height="10px" />}
                        {provider || "Склад + Тракмоторс"}{" "}
                        {info?.responceTime && `${info?.responceTime} c`}
                      </div>
                    )}
                  </div>

                  {isSearchResult && !result.length && !analogs.length && !brands.length && (
                    <h4>Ничего не найдено. Измените параметры поиска</h4>
                  )}
                </CardBody>
              </Card>
              <SearchResultTable
                result={result}
                setId={setId}
              />

              {analogs.length > 0 && (
                <>
                  <Card className="mb-0">
                    <CardBody className="pb-1">
                      <h3>
                        Аналоги
                        {analogs.length > 0 && (
                          <span className="ml-2 dashboard__results-count">
                            {analogs.length}
                          </span>
                        )}
                      </h3>
                    </CardBody>
                  </Card>
                  <SearchResultTable
                    result={analogs}
                    setId={setId}
                  />
                </>
              )}
            </div>
          </Col>
        </Row>
      </div>

      <CartTable
        orderSuccess={orderSuccess}
        customer={customer}
        setCustomer={setCustomer}
      />

      <OrderForm
        customer={customer}
        setCustomer={setCustomer}
        account={account}
        setAccount={setAccount}
        getAndSetPrice={getAndSetPrice}
        setOrderSuccess={setOrderSuccess}
      />

    </Container >
  );
};
